var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid p-3 p-md-4"},[(!_vm.isLoading && _vm.hasAppliance)?_c('RouterView'):_vm._e(),(_vm.isLoading === true)?_c('div',{staticClass:"p-5 text-center"},[_c('i',{staticClass:"fad fa-spinner fa-fw fa-spin text-primary mr-4"}),_vm._v(" Nahrávám spotřebič ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }